export default __webpack_public_path__ + "static/media/Islamic_Story.8009eaa2.svg";